module.exports = __webpack_public_path__ + "img/popupimg.958696fb.svg";